const ColorCalenderCss = ({
    isdark,
    iscolour,
    iscolourDark,
}) => {
    return (
        <style>
            {`

.custom-calendar {
  width: 320px !important;
  height: 340px !important; 
  overflow: hidden !important;
}

/* inner calendar always fill full box */
.custom-calendar .react-calendar__viewContainer {
  height: 100% !important;
}

/* navigation fixed */
.custom-calendar .react-calendar__navigation {
  height: 45px !important;
}

/* force all views to occupy same space */
.custom-calendar .react-calendar__month-view,
.custom-calendar .react-calendar__year-view,
.custom-calendar .react-calendar__decade-view,
.custom-calendar .react-calendar__century-view {
  height: calc(100% - 45px) !important;
}
  .custom-calendar {
  background: ${isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3} !important;
  border-radius: 20px !important;
  padding: 15px !important;
  border: none !important;
  color: ${isdark === "light" ? "#000000" : "#ffffff"} !important;
}

.custom-calendar .react-calendar__navigation button {
  color: ${isdark === "light" ? "#000000" : "#ffffff"} !important;
  font-size: 18px !important;
  font-weight: 700 !important;
  background: transparent !important;
}


.custom-calendar .react-calendar__navigation button:hover {
  background: ${isdark === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.1)"} !important;
  border-radius: 8px;
}

/* --- WEEKDAYS (MON, TUE, WED...) --- */
.custom-calendar .react-calendar__month-view__weekdays {
  color: ${isdark === "light" ? "#4a5568" : "#cbd5e1"} !important;
  font-weight: bold;
 
}

.custom-calendar .react-calendar__year-view__months {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr); /* 3 months per row */
  gap: 10px 10px !important; /* row + column spacing */
  padding: 10px !important;
}

/* month buttons styling */
.custom-calendar .react-calendar__year-view__months button {
  height: 60px !important;
  border-radius: 12px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
  .custom-calendar .react-calendar__decade-view__years {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr); /* 3 columns */
  gap: 12px 10px !important;
  padding: 10px !important;
}
  .custom-calendar .react-calendar__century-view__decades {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr); /* same as year/month */
  gap: 12px !important;
  padding: 10px !important;
}

/* 2100-2200 type decade buttons */
.custom-calendar .react-calendar__century-view__decades button {
  height: 60px !important;
  border-radius: 12px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

/* each year button */
.custom-calendar .react-calendar__decade-view__years button {
  height: 60px !important;
  border-radius: 12px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}
/* --- GRID FORMATTING --- */
.custom-calendar .react-calendar__month-view__days {
  display: grid !important;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px 0px;
}
/* ✅ GLOBAL HOVER (ALL TILES: date, month, year, decade) */
.custom-calendar .react-calendar__tile:hover,
.custom-calendar .react-calendar__year-view__months button:hover,
.custom-calendar .react-calendar__decade-view__years button:hover,
.custom-calendar .react-calendar__century-view__decades button:hover {
 background: ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour8} !important;

}
/* --- TILES BASE STYLE --- */
.custom-calendar .react-calendar__tile {
  color: ${isdark === "light" ? "#000000" : "#ffffff"} !important;
  border-radius: 0 !important;
  border: none !important;
  padding: 10px 0 !important;
  background: transparent;
}

/* Normal Day Hover */
.custom-calendar .react-calendar__tile:hover {
  background: ${isdark === "light" ? "rgba(59, 130, 246, 0.15)" : "rgba(59, 130, 246, 0.3)"} !important;
  color: ${isdark === "light" ? "#000000" : "#ffffff"} !important;
}

/* --- TODAY'S DATE HIGHLIGHT --- */
.custom-calendar .react-calendar__tile--now {
  background: ${isdark === "light" ? "#e2e8f0" : "#ffffff"} !important;
  border-radius: 50% !important;
  color: #000000 !important; 
  font-weight: bold;
}
.custom-calendar .react-calendar__tile--hasActive {
  background: ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour8
                } !important;
  color: white !important;
}
  /* Selected Year */
.custom-calendar .react-calendar__decade-view__years .react-calendar__tile--active {
  background: ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour8
                } !important;
  color: #fff !important;
}

/* Current selected year group */
.custom-calendar .react-calendar__decade-view__years .react-calendar__tile--hasActive {
  background: ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour8
                } !important;
  color: #fff !important;
}
/* --- SELECTED RANGE HIGHLIGHT --- */
.custom-calendar .react-calendar__tile--range {
  background: ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour8} !important;
  color: ${isdark === "light" ? "#000000" : "#ffffff"} !important;
  border-radius: 0 !important;
}

.custom-calendar .react-calendar__tile--rangeStart {
  background: ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour8} !important;
  color: white !important;
  border-radius: 12px 0 0 12px !important;
}

.custom-calendar .react-calendar__tile--rangeEnd {
  background: ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour8} !important;
  color: white !important;
  border-radius: 0 12px 12px 0 !important;
}

/* --- HOVER WHILE SELECTING RANGE --- */
.custom-calendar .react-calendar__tile--hover,
.custom-calendar .react-calendar__tile--hoverStart,
.custom-calendar .react-calendar__tile--hoverEnd,
.custom-calendar .react-calendar__tile--rangeStart:hover, 
.custom-calendar .react-calendar__tile--rangeEnd:hover {
  background: ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour8} !important;
  color: white !important;
}
/* Active selected tile */
.custom-calendar .react-calendar__tile--active {
  background: ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour8
                } !important;
  color: #fff !important;
}
/* Month / Year / Decade active item */
.custom-calendar .react-calendar__year-view__months .react-calendar__tile--active,
.custom-calendar .react-calendar__decade-view__years .react-calendar__tile--active,
.custom-calendar .react-calendar__century-view__decades .react-calendar__tile--active {
  background: ${isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour8
                } !important;
  color: #fff !important;
}

.custom-calendar .react-calendar__tile--hoverStart {
  border-radius: 12px 0 0 12px !important;
}
.custom-calendar .react-calendar__tile--hoverEnd {
  border-radius: 0 12px 12px 0 !important;
}
/* Active Clicked State */
.custom-calendar .react-calendar__tile--active {
  color: white !important;
}
 @media (max-width: 576px) {
  .custom-calendar {
    width: 100% !important;
    height: 280px !important;
    padding: 6px !important;
  }

  .custom-calendar .react-calendar__navigation {
    height: 35px !important;
    margin-bottom: 2px !important;
  }

  .custom-calendar .react-calendar__navigation button {
    font-size: 13px !important;
    min-width: 30px !important;
  }

  .custom-calendar .react-calendar__navigation__label {
    font-size: 12px !important;
  }

  .custom-calendar .react-calendar__month-view__weekdays {
    font-size: 10px !important;
  }

  .custom-calendar .react-calendar__tile {
    padding: 4px 0 !important;
    font-size: 11px !important;
    min-height: 28px !important;
  }

  /* Month / Year / Decade spacing increase */
  .custom-calendar .react-calendar__year-view__months,
  .custom-calendar .react-calendar__decade-view__years,
  .custom-calendar .react-calendar__century-view__decades {
    gap: 8px !important;
    padding: 8px !important;
  }

  .custom-calendar .react-calendar__year-view__months button,
  .custom-calendar .react-calendar__decade-view__years button,
  .custom-calendar .react-calendar__century-view__decades button {
    height: 42px !important;
    min-height: 42px !important;
    font-size: 11px !important;
  }

  .date-picker-footer {
    margin-top: 0 !important;
    padding: 2px !important;
  }

  .date-picker-footer button {
    font-size: 12px !important;
    padding: 6px 12px !important;
  }
}
} 
  `}
        </style>
    );
};

export default ColorCalenderCss;